import { useEffect } from "react";
import { BRAND, pageTitle } from "@neus/shared";

/** The browser tab's title on this page: `title` before the store's name, or the store's site title. */
export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = pageTitle(title);
    // Most shopping pages set no title of their own, so leave the store's.
    return () => {
      document.title = BRAND.site.title;
    };
  }, [title]);
}
